import invoice from "../images/Work/InvoiceList.png";
import blog from "../images/Work/blog.png";
import saeloun from "../images/Work/saeloun.png";

export const work = [
    {
        link: "#/case-study-miru",
        img: invoice,
        description: "Developed over 70% of the core frontend",
        name: "Miru→",
    
    },
    {
        link: "#/case-study-saeloun",
        img: saeloun,
        description: "Clients page, SEO optimization & blog migration",
        name: "Saeloun→",
    },
    {
        link: "#/case-study-blog",
        img: blog,
        description: "Categories redevelopment led to traffic enhancement",
        name: "Saeloun Blog→",
    },

];